import { useQuery } from 'react-query';
import { QUERY_KEYS } from 'api/query-keys';
import { Certificate } from '@types';
import { CACHE_TIME_LONG, STALE_TIME_LONG } from 'shared/react-query/query-defaults';
import { getAvailableCertificates } from 'shared/services/certificate-service';

export const useAvailableCertificates = () => {
  const query = useQuery<Certificate[], Error>(QUERY_KEYS.publicCertificates(), {
    queryFn: getAvailableCertificates,
    cacheTime: CACHE_TIME_LONG,
    staleTime: STALE_TIME_LONG,
  });

  return {
    ...query,
    items: query.data ?? [],
  };
};
